import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const addFiles = async ({ msgId, files }) => {
  return await Promise.allSettled(
    files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);

      return await request.post(
        `Question/note_attachment/${msgId}`,
        formData,
        `При добавлении файла ${file.name} к сообщению произошла ошибка`
      );
    })
  );
};

const useAddMsgAttachmentsMutation = (options) => {
  return useMutation(addFiles, options);
};

export default useAddMsgAttachmentsMutation;
